import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import Item from './Item';

const List = ({ episodes, onAddRestream, onApply, onEditRestream }) => {
	const grouped = React.useMemo(() => episodes.reduce((groups, episode) => {
		const day = moment(episode.start).format('YYYY-MM-DD');
		return {
			...groups,
			[day]: [
				...groups[day] || [],
				episode,
			],
		};
	}, {}), [episodes]);

	return <div className="episodes-list">
		{Object.entries(grouped).map(([day, group]) => <div key={day}>
			<h2 className="text-center episodes-group-heading">
				{moment(day).format('dddd, L')}
			</h2>
			{group.map(episode =>
				<Item
					episode={episode}
					onAddRestream={onAddRestream}
					onApply={onApply}
					onEditRestream={onEditRestream}
					key={episode.id}
				/>
			)}
		</div>)}
	</div>;
};

List.propTypes = {
	episodes: PropTypes.arrayOf(PropTypes.shape({
		start: PropTypes.string,
	})),
	onAddRestream: PropTypes.func,
	onApply: PropTypes.func,
	onEditRestream: PropTypes.func,
};

export default List;
